import { Select } from 'antd'
import { t } from 'i18next'
import { useCallback, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { SelectOption } from '../../../../types/generalTypes'
import { routePaths } from '../../../RootPage'
import styled from 'styled-components'
import { smartFunctionViewTypes } from '../../components/SmartFunctionViewTypeDropdown'

export type FlowCytometryReviewAnalysisPanel =
  | 'GATE_REVIEW'
  | 'COMPENSATION_MATRIX_REVIEW'
  | 'GATE_LOCK_REVIEW'
  | 'ADDITIONAL_ANALYSIS_FILE_REVIEW'
export interface FlowCytometryReviewAnalysisPanels {
  GATE_REVIEW: FlowCytometryReviewAnalysisPanel
  COMPENSATION_MATRIX_REVIEW: FlowCytometryReviewAnalysisPanel
  GATE_LOCK_REVIEW: FlowCytometryReviewAnalysisPanel
  ADDITIONAL_ANALYSIS_FILE_REVIEW: FlowCytometryReviewAnalysisPanel
}
export const flowCytometryReviewAnalysisPanels: FlowCytometryReviewAnalysisPanels =
  {
    GATE_REVIEW: 'GATE_REVIEW',
    COMPENSATION_MATRIX_REVIEW: 'COMPENSATION_MATRIX_REVIEW',
    GATE_LOCK_REVIEW: 'GATE_LOCK_REVIEW',
    ADDITIONAL_ANALYSIS_FILE_REVIEW: 'ADDITIONAL_ANALYSIS_FILE_REVIEW',
  }

const StyledSelect = styled(Select)`
  width: 250px;
`

const FlowCytometryReviewAnalysisSelectPanel = () => {
  const { workspaceId, algorithmRunId, panel } = useParams()
  const navigate = useNavigate()

  const [selectedValue, setSelectedValue] = useState<string | undefined>(panel)

  const handleChange = useCallback(
    (value?: string) => {
      setSelectedValue(value)
      const url = `${routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_CC_FC_REVIEW_ANALYSIS}/${workspaceId}/${algorithmRunId}/${smartFunctionViewTypes.TABLE}/${value}`
      navigate(url)
    },
    [workspaceId, algorithmRunId, navigate]
  )

  const options: SelectOption[] = useMemo(
    () => [
      {
        label: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.panels.gateReview'
        ),
        value: flowCytometryReviewAnalysisPanels.GATE_REVIEW,
      },
      {
        label: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.panels.compensationMatrixReview'
        ),
        value: flowCytometryReviewAnalysisPanels.COMPENSATION_MATRIX_REVIEW,
      },
      {
        label: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.panels.gateLockReview'
        ),
        value: flowCytometryReviewAnalysisPanels.GATE_LOCK_REVIEW,
      },
      {
        label: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.panels.additionalAnalysisFileReview'
        ),
        value:
          flowCytometryReviewAnalysisPanels.ADDITIONAL_ANALYSIS_FILE_REVIEW,
      },
    ],
    []
  )

  return (
    <StyledSelect
      onChange={handleChange}
      defaultValue={panel}
      value={selectedValue}
      options={options}
    />
  )
}

export default FlowCytometryReviewAnalysisSelectPanel
